import { NgModule } from '@angular/core';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
    faCamera, faUsersClass, faCaretSquareDown, faPlusSquare, faTrash, faTrashUndo, faSave, faList,
    faUserCog, faUsersCog, faProjectDiagram, faCogs, faWindowClose, faUserPlus, faRedo, faCircle, faStar,
    faSearch, faTools, faUsers, faRunning, faClub, faUserGraduate, faFileExcel, faTimesSquare, faBooks,
    faNotesMedical, faSirenOn, faHouseLeave, faSync, faFileExport, faUserChart, faBookUser, faUserFriends,
    faUser, faUserCircle, faUserLock, faSignOut, faSignIn, faUserUnlock, faArchive, faFilePlus, faRetweetAlt,
    faPlay, faFilter, faBan, faGraduationCap, faColumns, faUserMd, faCubes, faTags, faSitemap, faEye, faListUl, faUndo,
    faUpload, faUndoAlt, faArrowToRight, faArrowToLeft, faBoxOpen, faCheck, faFileArchive, faFilePdf, faTimesCircle, faCheckCircle,
    faCheckSquare, faEdit, faPencil, faExclamationTriangle, faBell, faChevronLeft, faChevronRight, faHome, faMoneyBill, faComment,
    faEnvelope, faEnvelopeOpenText, faUserSecret, faChartBar, faServer, faCog, faTimes, faInfoCircle, faMobile, faShieldCheck, faCameraRetro
} from '@fortawesome/pro-duotone-svg-icons';


@NgModule({
    imports: [FontAwesomeModule],
    exports: [FontAwesomeModule]
})
export class IconsModule {
    /**
     * Constructor
     */
    constructor(
        private library: FaIconLibrary
    ) {

        //** Registers the fontawesome icons */
        this.library.addIcons(faCamera, faUsersClass,
            faCaretSquareDown, faPlusSquare, faTrash, faTrashUndo, faSave, faList, faCircle, faStar,
            faUserCog, faUsersCog, faProjectDiagram, faCogs, faWindowClose, faUserPlus, faRedo, faSearch, faTools,
            faUsers, faRunning, faClub, faUserGraduate, faFileExcel, faTimesSquare, faBooks, faNotesMedical,
            faSirenOn, faHouseLeave, faSync, faFileExport, faUserChart, faBookUser, faUserFriends, faUser, faUserCircle,
            faUserLock, faSignOut, faSignIn, faUserUnlock, faArchive, faFilePlus, faRetweetAlt, faPlay, faFilter, faBan,
            faGraduationCap, faColumns, faUserMd, faCubes, faTags, faSitemap, faEye, faListUl, faUndo, faUpload, faUndoAlt,
            faArrowToRight, faArrowToLeft, faBoxOpen, faCheck, faFileArchive, faFilePdf, faTimesCircle, faCheckCircle,
            faCheckSquare, faEdit, faPencil, faExclamationTriangle, faBell, faChevronLeft, faChevronRight, faHome, faMoneyBill,
            faComment, faEnvelope, faEnvelopeOpenText, faUserSecret, faExclamationTriangle, faFileArchive, faChartBar,
            faServer, faCog, faTimes, faInfoCircle, faMobile, faShieldCheck, faCameraRetro);
    } //This is a comment

}
